


















import Base from './Base.vue';

export default Base.extend({
	name: 'PrehledPracProTiskCarKodu',
	components: {
		BaseFilterSestav: Base,
	},
});
